import { Type } from 'class-transformer';
import UserModel from '@/models/user.model';
import ContactModel from './contact.model';
import ConversationModel from './conversation.model';

export default class PinnedChatModel {
  id!: number;

  inclusaoData!: string;

  @Type(() => UserModel)
  atendente!: UserModel;

  @Type(() => ContactModel)
  contato!: ContactModel;

  @Type(() => ConversationModel)
  conversa!: ConversationModel;
}
